import { render, staticRenderFns } from "./GraphDetail24.vue?vue&type=template&id=68c8e84e&scoped=true"
import script from "./GraphDetail24.vue?vue&type=script&lang=js"
export * from "./GraphDetail24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c8e84e",
  null
  
)

export default component.exports